export enum LoanRepaymentType {
  Custom = "Custom",
  LoanPlusInterest = "LoanPlusInterest",
}
